import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function JoinMember() {
  const { user } = useAuth();
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    if (p.get("invite")) localStorage.setItem("velluto_invite", p.get("invite").slice(0, 20));
    if (p.get("utm_source")) {
      localStorage.setItem("velluto_src", JSON.stringify({
        source: p.get("utm_source").slice(0, 80), medium: (p.get("utm_medium") || "").slice(0, 80),
        campaign: (p.get("utm_campaign") || "").slice(0, 120), landing: "/vip", intent: "member",
      }));
    }
    sessionStorage.setItem("velluto_next", "/premium");
    localStorage.setItem("velluto_after_confirm", "/premium");
  }, []);
  if (user === null) return <div className="pt-32 text-center text-text-muted">Loading…</div>;
  return <Navigate to={user ? "/premium" : "/auth?mode=register&vip=1"} replace />;
}
